// Reviews
const howToUse = document.querySelector('.how-to-use');

if (howToUse) {
  const steps = new Swiper(howToUse, {
    draggable: true,
    grabCursor: true,
    slideToClickedSlide: true,
    centeredSlidesBounds: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
      },
      480: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 4,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        mousewheel: {
          enabled: true,
          sensitivity: 4,
        }
      },
    },
  });
}
